/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobCloudProviderQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobCloudProviderQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobCloudProviderQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobCloudProviderQueryOperator>): PolicyJobCloudProviderQueryOperator {
        let obj = Object.assign(new PolicyJobCloudProviderQueryOperator(), model);
        PolicyJobCloudProviderQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobCloudProviderQueryOperator>): PolicyJobCloudProviderQueryOperator {
        if (!model) return null;
        return PolicyJobCloudProviderQueryOperator.newInstance(<PolicyJobCloudProviderQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobCloudProviderQueryOperator) {
        if (!obj) return;

        models.PolicyJobCloudProviderQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobCloudProviderQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobCloudProviderQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud providers to include
     */
    cloud_providers: Array<models.CloudServiceName>;

}
